import template from './index.jst';
import './index.styl';
import { View } from 'backbone.marionette';
import { Secret } from '../../../../core/utils';
import { Model } from 'backbone';
const IS_PRE_SEASON = JSON.parse(process.env.IS_PRE_SEASON);

export class OffSeasonView extends View {
	get template() {
		return template;
	}

	get className() {
		return "off-season";
	}

	get model(){
		return new Model({
			IS_PRE_SEASON: Secret.is_passed ? false : IS_PRE_SEASON
		});
	}
}

export default OffSeasonView;